const CenteredText = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        textAlign: 'center'
      }}
    >
      {children}
    </div>
  )
}

export default CenteredText
